import { useMemo } from 'react';

import { useMediaQuery as useRootMediaQuery } from '@mui/material';

import { stringifyMediaQueryObj } from '../util/responsive/media-queries';
import { type MediaQueryObj } from '../util/responsive/types';

export const useMediaQuery = (query: MediaQueryObj | string): boolean => {
  const cssQuery = useMemo(() => {
    if (typeof query === 'string') {
      return query;
    }
    return stringifyMediaQueryObj(query, { prefix: '@media' });
  }, [query]);

  return useRootMediaQuery(cssQuery);
};
